import { render, staticRenderFns } from "./SetupCrowd.vue?vue&type=template&id=afd4f6ca&scoped=true"
import script from "./SetupCrowd.vue?vue&type=script&lang=js"
export * from "./SetupCrowd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4f6ca",
  null
  
)

export default component.exports